import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

interface Settings {
  debug: boolean;
  questions: number;
  detail_delay: number;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public settings: Settings;

  constructor(private http: HttpClient) {
    this.getSettings().subscribe(data => this.settings = data);
  }

  getSettings(): Observable<Settings> {
    return this.http.get<Settings>('config.json');
  }
}
